import { Routes } from "Routes";
import React from "react";

export const App = () => {
  //temp
  return <Routes />;
};
